import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { DateTime } from 'luxon'
import {
  formatImpactType,
  IMPACT_TYPE_DATE_CANCELLATION,
} from './getUpdateImpact'

const formatDateTime = (iso, timezone) => {
  const dt = DateTime.fromISO(iso, { zone: timezone })
  return `${dt.toFormat('EEEE, LLL d')} at ${dt.toFormat('h:mm a')}`
}

const formatRegistrants = registrants =>
  registrants
    .map(({ student }) => `${student.firstName} ${student.lastName}`)
    .join(', ')

const UpdateReasonDialog = ({
  open,
  impacts,
  timezone,
  updateReason,
  onUpdateReasonChange,
  onConfirm,
  onCancel,
}) => {
  const hasDateCancellation = impacts.some(impact =>
    (Array.isArray(impact.type) ? impact.type : [impact.type]).includes(
      IMPACT_TYPE_DATE_CANCELLATION,
    ),
  )

  return (
    <Dialog maxWidth="sm" fullWidth open={open}>
      <DialogTitle>This update will notify event attendees</DialogTitle>
      <DialogContent>
        {impacts.length === 0 ? (
          <Typography gutterBottom>
            Updating the <strong>Location</strong> or the{' '}
            <strong>Schedule</strong> of an event will automatically inform the
            attendees of the changes. Use the form below if you would like to
            add a custom message.
          </Typography>
        ) : (
          <>
            <Typography gutterBottom>
              The following attendees will be notified because this update
              affects them. Use the form below if you would like to add a custom
              message.
            </Typography>
            <List dense disablePadding>
              {impacts.map((impact, index) => {
                const key = impact.occurrence
                  ? `${impact.occurrence.id}-${index}`
                  : `all-${index}`
                const primary = impact.occurrence
                  ? `${formatDateTime(
                    impact.occurrence.startDateTime,
                    timezone,
                  )} — ${formatImpactType(impact.type)}`
                  : formatImpactType(impact.type)
                const secondary = formatRegistrants(impact.registrants)

                return (
                  <ListItem key={key} disableGutters>
                    <ListItemText primary={primary} secondary={secondary} />
                  </ListItem>
                )
              })}
            </List>
          </>
        )}
        {hasDateCancellation ? (
          <Typography gutterBottom color="error">
            Canceled dates will notify registered attendees. Any paid
            registrants must be refunded manually.
          </Typography>
        ) : null}
        <br />
        <Typography gutterBottom>
          <strong>Provide a Reason</strong> (optional)
        </Typography>
        <TextField
          multiline
          rows={4}
          name="updateReason"
          label="Reason for Update"
          value={updateReason}
          onChange={onUpdateReasonChange}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="contained" onClick={onConfirm}>
          Update Event
        </Button>
        <Button color="primary" onClick={onCancel}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UpdateReasonDialog
